exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alig-skew[data-v-6f7d42d8]{position:absolute;-webkit-transform:skewY(0deg) translateY(-218px);transform:skewY(0deg) translateY(-218px);background:#fff;padding:7em 0;z-index:-1;width:100%}.without-overflow[data-v-6f7d42d8]{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f7d42d8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/BaseConcurso.vue
// module id = jrFI
// module chunks = 0